import React, { useEffect, useState } from 'react'
import { type RootState } from '../../../../store/store'
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux'
import AdvertiseListItem from './AdvertiseListItem'
import { advertisesSlice, type IAdvertise } from '../../../../store/slices/advertisesSlice'
import { nanoid } from 'nanoid'
import { getStatusesAdvertisements } from '../../../../functions/agent/schedule/getStatusesAdvertisements'
import useSaveScroll from '../../../../hooks/useSaveScroll'
import { List } from 'antd'
import {
    aprImage,
    cancelledImage, closedImage,
    completedImage, docsReceivedImage, linksAddedImage, linksApprovedImage, linksRejectedImage,
    othrImage,
    placeholders,
    prImage,
    rejImage,
    startedImage,
    USER_ID_KEY
} from '../../../../urls'
import { ScheduleAccordion } from '../ScheduleAccordion'
interface IProps {
    advertises: IAdvertise[] | []
}

export default function AdvertiseList({ advertises }: IProps): JSX.Element {
    const userID = window.localStorage.getItem(USER_ID_KEY)
    const dispatch = useAppDispatch()
    const [expanded, setExpanded] = useState<string | false>(false);
    const advertisesScrollPosition = useAppSelector((state: RootState) => state.advertises.advertisesScrollPosition)
    const units = useAppSelector((state: RootState) => state.units.units)
    const queueAds = units.reduce((acc: number[], unit) => {
        unit.attributes.WaitingList?.forEach((reserve) => {
            if (reserve.userID === Number(userID)) {
                acc.push(reserve.adId);
            }
        });
        return acc;
    }, []);

    const statuses = getStatusesAdvertisements(advertises, queueAds) as any[] | []

    useEffect(() => {
        setTimeout(() => {
            window.scrollTo({ top: Number(advertisesScrollPosition), behavior: 'smooth' })
        }, 100)
    }, [])

    useEffect(() => {
        // console.log('useEffect scroll ADVERTISES')
        const scrollWrapper = document.querySelector('#root')

        const handleScroll = (event: Event): void => {
            const target = event?.target as HTMLElement
            if (target.scrollTop > 0) {
                dispatch(advertisesSlice.actions.setAdvertisesScrollPosition(target.scrollTop))
            }
        }
        scrollWrapper?.addEventListener('scroll', handleScroll, { passive: true })

        return () => {
            scrollWrapper?.removeEventListener('scroll', handleScroll)
        }
    }, [])


    const statusImages: any = {
        Approved: aprImage,
        Rejected: rejImage,
        Canceled: cancelledImage,
        Completed: completedImage,
        'In-process': prImage,
        'Advertisement started': startedImage,
        'Docs received': docsReceivedImage,
        'Advertisement closed': closedImage,
        'Links added': linksAddedImage,
        'Links rejected': linksRejectedImage,
        'Links approved': linksApprovedImage,
        "Other": othrImage
    }


    return (
        <>
            {(statuses && statuses.length > 0) || queueAds.length > 0 ? (
                statuses.map((item: any) => {
                    return item.advertisementsLength > 0 ? (
                        <ScheduleAccordion
                            key={item.status}
                            group={item.status}
                            expanded={expanded}
                            setExpanded={setExpanded}
                            countLable={item.advertisementsLength}
                            imgCover={statusImages[item.status] || statusImages['In-process']}
                        >
                            <AdvertiseListItem key={item.id} {...item} />
                        </ScheduleAccordion>
                    ) : null
                })
            ) : (
                <div className={'d-flex position-relative align-items-end'}>
                    <img
                        className="w-75 object-fit-cover m-auto rounded rounded-4 opacity-100  mt-8"
                        src={placeholders.Advertisements}
                        alt={'liable_picture'}
                    />
                    <span className="fs-2x fs-lg-2 fw-bold text-white text-uppercase position-absolute text-center" style={{ bottom: '14%', left: '50%', transform: 'translateX(-50%)', textShadow: '1px 1px 10px #332d2dd9' }}>
                        You don’t have any active advertisements yet
                    </span>
                </div>
            )}
        </>
    )
}
